import ControlButton, {type ControlButtonProps} from "./ControlButton.tsx";

export const DefaultButton = (props: ControlButtonProps) => {
    const {className, ...rest} = props;
    return (
        <ControlButton
            className={`bg-save-button ${className}`}
            {...rest}
        />
    );
};
